export const freeFeatures = ["Create 25 notes per month", "Send 25 chat messages per month"];

export const proFeatures = [
  "Dark mode",
  "Unlimited notes",
  "Unlimited chat messages",
  "Unlimited deep searches",
  "Unlimited collections",
  "Unlimited templates",
  "Unlimited connected emails",
  "Unlimited connected calendars",
  "Unlimited API keys",
];
